import { Paper, Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const Container = styled(Paper)({
  borderRadius: '0',
  width: '100%',
  padding: '10px',
  maxHeight: '85px',
  height: '100%',
  '&:not(:last-child)': {
    marginBottom: '10px',
  },
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  boxShadow: '0 2px 4px 0 rgba(0,0,0,0.08), 0 0 8px 0 rgba(0,0,0,0.10)',
  alignContent: 'center',
  overflow: 'hidden',
  justifyContent: 'space-between',

  '@media (max-width: 1120px)': {
    maxHeight: 'fit-content',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
});

export const General = styled(Grid)({
  display: 'flex',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    justifyContent: 'space-between',
  },
});

export const ColumnWrapper = styled(Grid)(
  {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '380px',
    width: '100%',
    justifyContent: 'space-between',
  },
  ({ reverse }) => ({
    [theme.breakpoints.down('md')]: {
      maxWidth: '280px',
      flexDirection: reverse === 'true' ? 'column-reverse' : 'column',
      alignItems: 'flex-start',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '135px',
    },
  })
);

const widths = {
  'first-cell': '100px',
  'second-cell': '200px',
  'third-cell': '100px',
  'forth-cell': '200px',
  'fifth-cell': '350px',
  'six-cell': '100px',
};
const paddLeft = {
  'first-cell': '10px',
  'second-cell': '10px',
  'third-cell': '10px',
  'forth-cell': '10px',
  'fifth-cell': '20px',
  'six-cell': '10px',
};
const mdAlignSelf = {
  'first-cell': 'initial',
  'second-cell': 'initial',
  'third-cell': 'flex-end',
  'forth-cell': 'initial',
  'fifth-cell': 'initial',
  'six-cell': 'center',
};

export const Cell = styled(Grid)(
  {
    padding: '10px',
    alignSelf: 'center',
    width: '100%',
  },
  ({ id }) => ({
    width: widths[id],
    // marginLeft: id === 'six-cell' && 'auto',
    paddingBottom: id === 'third-cell' && '22px',
    paddingLeft: paddLeft[id],
    textAlign: id === 'six-cell' && 'end',
    alignSelf: id === 'third-cell' && 'flex-end',
    marginRight: id === 'third-cell' && '40px',
    minWidth: id === 'third-cell' && '100px',

    [theme.breakpoints.down('md')]: {
      alignSelf: mdAlignSelf[id],
      padding: id === 'third-cell' ? '10px 10px 20px' : '10px',
      // paddingLeft: id === 'fifth-cell' && '50px',
      // width: id === 'fifth-cell' && '180px',
    },
    '@media(max-width: 700px)': {
      margin: id === 'six-cell' && 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      padding: id === 'third-cell' ? '10px 5px 45px' : '10px 0',
      // paddingRight: id === 'fifth-cell' && '10px',
      width: 'fit-content',
      marginRight: id === 'third-cell' && '10px',
    },
    '@media(max-width: 400px)': {
      minWidth: id === 'third-cell' && '50px',
      marginRight: id === 'third-cell' && '35px',
    },
  })
);

export const Details = styled(Typography)({
  ...theme.typography.link,
});
